import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import SortIcon from '@material-ui/icons/Sort';
import Button from '@material-ui/core/Button';
import getSortMethod from './Sort';
import { injectIntl } from 'react-intl';
import ToCamelCase from "../Utils/ToCamelCase";

const styles = theme => ({
  root: {
    display: 'inline-block',
  },
  button: {
    margin: theme.spacing(1),
  },
});

const options = [
  ['none', ''],
  ['modifiedRev', 'Last modified'],
  ['modified', 'Oldest modified'],
  ['createdRev', 'Last created'],
  ['created', 'Oldest created'],
  ['title', 'Title (A-Z)'],
  ['titleRev', 'Title (Z-A)'],
];

const defaultTitle = "Sort By";

const localSortRule = localStorage.getItem("sortRule") ? JSON.parse(localStorage.getItem("sortRule")) : null;

class SimpleListMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      selectedIndex: localSortRule ? options.findIndex((arr) => arr[1].toLowerCase() === localSortRule.displayName.toLowerCase()) : 0,
    }
  }

  currentSortMethod() {
    const [name, displayName] = options[this.state.selectedIndex];
    return { name, displayName };
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuItemClick = (event, index) => {
    const { handleSortChange, intl } = this.props;
    this.setState({ selectedIndex: index, anchorEl: null }, () => {
      handleSortChange(getSortMethod(this.currentSortMethod().name), this.getCurrentDisplayName());
      localStorage.setItem(
        'sortRule',
        JSON.stringify({
          ...this.currentSortMethod(),
          displayName: intl.formatMessage({ id: `sort.${ToCamelCase(this.currentSortMethod().displayName)}` })
        })
      );
    });
  };

  getCurrentDisplayName = () => {
    const { intl } = this.props;
    const sortMethod = this.currentSortMethod();
    if (sortMethod.name === 'none') {
      return intl.formatMessage({ id: ToCamelCase(defaultTitle) });
    }
    return intl.formatMessage({ id: `sort.${ToCamelCase(sortMethod.displayName)}` });
  };

  componentDidMount() {
    const { handleSortChange } = this.props;
    if(localSortRule) {
      handleSortChange(getSortMethod(localSortRule.name), localSortRule.displayName);
    }
  }

  render() {
    const { classes, intl } = this.props;
    const { anchorEl } = this.state;

    return (
      <div className={classes.root}>
        <Button className={classes.button} aria-label="Sort" onClick={this.handleOpen}>
          <SortIcon className={classes.leftIcon} />
          {this.getCurrentDisplayName()}
        </Button>
        <Menu
          id="sort-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {options.slice(1).map(([_, displayName], index) => (
            <MenuItem
              key={displayName}
              selected={(index + 1) === this.state.selectedIndex}
              onClick={event => this.handleMenuItemClick(event, (index + 1))}
            >
              {intl.formatMessage({ id: `sort.${ToCamelCase(displayName)}` })}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

SimpleListMenu.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  handleSortChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(injectIntl(SimpleListMenu));
